import { useQuery } from '@tanstack/react-query';
import { type ProposalAcceptanceHistoryItem, proposalApi } from '@/api/commercial/proposals';

export function useProposalAcceptanceHistory(proposalId?: string, enabled = false) {
  return useQuery<ProposalAcceptanceHistoryItem[]>({
    queryKey: ['proposal-acceptance-history', proposalId],
    queryFn: () =>
      proposalId ? proposalApi.getAcceptanceHistory(proposalId) : Promise.resolve([]),
    enabled: !!proposalId && enabled,
    staleTime: 60 * 1000,
    retry: false,
  });
}
